import { jsx as _jsx } from "react/jsx-runtime";
import { DotLoader } from "syf-component-library/ui/atoms";
import vantageI18n from "../../../../../strings/i18n";
var unenrollButtonContent = function (isLoading) {
    if (isLoading) {
        return _jsx(DotLoader, {});
    }
    return vantageI18n.t("unenrollModal.unenroll");
};
export default unenrollButtonContent;
